import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';

const PixelConversion = React.lazy(() => import('./PixelConversion'));

export default class PixelConversionWrapper extends Component {
  render() {
    return (
      <div>
        <Suspense>
          <PixelConversion config={this.props.config} />
        </Suspense>
      </div>
    );
  }
}

PixelConversionWrapper.propTypes = {
  config: PropTypes.object.isRequired,
};
